// src/js/main/contact.js

/**
 * Hanterar logiken för flik-växlaren på kontaktsidan.
 */
function initializeContactToggler() {
    const togglerContainer = document.querySelector('.main-content-card');
    // Avbryt om huvudcontainern inte finns på sidan.
    if (!togglerContainer) {
        return;
    }

    const togglerLinks = togglerContainer.querySelectorAll('.contact-toggler a');
    const contentPanes = togglerContainer.querySelectorAll('.content-pane');

    togglerLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const targetId = this.dataset.target;
            const targetPane = togglerContainer.querySelector(targetId);
            
            if (this.classList.contains('active')) {
                return;
            }

            togglerLinks.forEach(l => l.classList.remove('active'));
            this.classList.add('active');

            contentPanes.forEach(pane => pane.classList.remove('is-active'));
            if (targetPane) {
                targetPane.classList.add('is-active');
            }
        });
    });
    console.log('Contact Toggler initialized.');
}

/**
 * Hanterar URL-parametrar för att förvälja en flik.
 */
function handleUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('view') === 'booking') {
        const bookingTabButton = document.querySelector('.contact-toggler a[data-target="#booking-pane"]');
        
        // Klicka på knappen om den finns, för att aktivera rätt flik.
        if (bookingTabButton) {
            bookingTabButton.click();
            console.log('Booking tab pre-selected from URL.');
        }
    }
}


// Kör all logik för kontaktsidan när sidan har laddats.
document.addEventListener('DOMContentLoaded', () => {
    initializeContactToggler();
    handleUrlParameters();
});